// extracted by css-extract-rspack-plugin
export default {"cls1":"Loading-cls1_u_e","cls2":"Loading-cls2_t8g Loading-cls1_u_e","showMobile":"Loading-showMobile_U_b"};